import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';

export const Title = styled.h1`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2}
    margin: 32px 0 18px;
`;
